import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import SVGInline from 'react-svg-inline'

// utils
import { getHours } from '../../../../utils';

// svgs
import clockSVG from '../../../inlineSVGs/clockSVG';


// styles
import './Date.css';

const Date = ({ date, time, wrapperStyle }) => {

    const getHour = () => {
        return getHours(time);
    };

    const formatDate = () => {
        // example: Sunday, September 23, 2019

        return moment(date).format('dddd, MMMM D, YYYY');
    };

    return (
            <div className="modal-date-wrapper" style={wrapperStyle}>
                <SVGInline className="clock-icon" svg={clockSVG} component="i"/>
                <p className="hour">{getHour()}</p>
                <p className="date">{formatDate()}</p>
            </div>
    )
};

Date.propTypes = {
    date: PropTypes.string,
    time: PropTypes.number,
    wrapperStyle: PropTypes.object
};

export default Date;



// WEBPACK FOOTER //
// ./src/Components/ModalsNew/ModalElements/Date/Date.js